import md5 from 'js-md5'
export default {
  //生成随机码
  createRandomCode: function (codeLength) {
    var randomCode = '';
    var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
    for (var i = 0; i < codeLength; i++) {
      var index = Math.floor(Math.random() * 9);
      randomCode += random[index];
    }
    return randomCode;
  },
  sign: function (appKey, appSecret, timeStamp, nonce) {
    var signature = '';
    var str = "appKey=" + appKey + "&nonce=" + nonce + "&timeStamp=" + timeStamp + "&appSecret=" + appSecret;
    signature = md5(str);
    return signature;
  }
}